import { Route, RouteComponentProps, RouteProps } from 'react-router-dom';

import { encodeUrl } from '../../common/helpers';
import { isSupportedLocale } from '../../i18n';
import { useSession } from '../Auth/SessionProvider';
import BrowserRedirect from './BrowserRedirect';
import LocaleProvider from '../../common/LocaleProvider';
import config from '../../config';

interface UserRouteProps extends RouteProps {
  render(route: RouteComponentProps<any>): any;
}

const UserRoute = ({ render, ...rest }: UserRouteProps) => {
  const { user } = useSession();

  if (!user) {
    return <BrowserRedirect to={`/login?${encodeUrl({ returnUrl: window.location.href })}`} />;
  }

  const locale = isSupportedLocale(user.locale) ? user.locale : config.fallbackLocale;

  return (
    <LocaleProvider locale={locale} localizeRequests={false}>
      <Route {...rest} render={(props) => render(props)} />
    </LocaleProvider>
  );
};

export default UserRoute;
